import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css'],
  providers: [MessageService]

})
export class AppLayoutComponent implements OnInit {
  onNotify: Subscription | undefined;

  constructor(private readonly notification: NotificationService, private readonly messageService: MessageService) {
    this.onNotify = this.notification.onNotifyEvent$.subscribe(response => {
      this.messageService.add(response)
  })
  }

  ngOnInit(): void {
    this.notification.sendNotificationLoginEvent.subscribe(res=>{
      this.messageService.add({
        key: 'login',
        severity: 'success',
        summary: res,
      });
    })

  }

}
